export const BACK_OFFICE_LOGO_VARIANTS = ["momentum", "apex", "signal", "ledger"] as const;

/** The one the app ships with. Swap this to switch the mark everywhere it is drawn. */
export const ACTIVE_BACK_OFFICE_LOGO_VARIANT: (typeof BACK_OFFICE_LOGO_VARIANTS)[number] = "signal";

/** Mark edge length per placement, in px. */
export const MARK_SIZES = {
  nav: 38,
  login: 48,
};

/** What `BackOfficeLogoMark` draws at when no size is given. */
export const DEFAULT_MARK_SIZE = MARK_SIZES.nav;
